export const posthogEnv = {
  host: process.env.NEXT_PUBLIC_POSTHOG_HOST ?? '',
  key: process.env.NEXT_PUBLIC_POSTHOG_KEY ?? ''
}
